const applicationMixin = {
    data() {
        return {
            RESOURCE_EKYZMAT_ID: 1,
            RESOURCE_LOCAL_POSITIONS_ID: 2,
            RESOURCE_NRK_ID: 3,
            RESOURCE_REGISTER_POST_ID: 13,
            MRK_RESOURCE_ID: 14,
            APP_TYPE_NRK: 2,
            APP_TYPE_EKYZMAT: 1,
            APP_TYPE_ATTESTATION: 3,
            APP_TYPE_RRK: 4,
            APP_TYPE_DEMO: 8,
            APP_TYPE_MRK: 5,
            form: {
                id: null,
                title: '',
                typeId: '',
                resourceId: '',
                resourceType: '',
                isTrial: false,
                testingDate: '',
                appType: '',
                officeId: '',
                appDate: ''
            },
            candidate: {
                candidateId: null,
                pin: '',
                fname: '',
                lname: '',
                pname: '',
                email: '',
                bdate: '',
                photoId: '',
                photoBase64: '',
                photoUrl: '',
            },
            candidateForm: {
                candidateId: null,
                pin: '',
                fname: '',
                email: '',
                lname: '',
                pname: '',
                bdate: '',
                photoId: '',
                photoBase64: '',
                photoUrl: '',
            },
            candidates: [],
            events: [],
            filterForm: {
                page: this.$route.query.page || 1,
                query: '',
                dispatchStatus: this.$route.query.distpatchStatus || '',
                dateFrom: '',
                dateTo: '',
                appOfficeId: '',
                status: this.$route.query.status || '',
            },
            zayavki: [],
            application: {
                id: this.$route.params.id || '',
            },
            formOptions: {
                types: [],
                notificationStatuses: [],
                resourceTypes: [],
                resources: [],
                statuses: [],
                offices: [],
                creationTypes: [],
                contestTypes: [],
                resourcePositions: [],
            },
        }
    },
    methods: {

        fetchApplicationCandidates(appId, pin = null) {

            let params = {};
            if (pin)
                params.pin = pin;
            else {
                params = this.cleanObject(this.filterForm);
            }

            this.$router.replace({query: params}).catch(() => {
            })

            return this.axios.get(this.$config.urls.application.fetchCandidates.url.replace(':id', appId), {params: params})
                .then(response => {
                    if (pin)
                        this.appCandidate = response.data.data;
                    else {
                        this.candidates = response.data.data.items;
                        this.pagination.currentPage = response.data.data.activePage;
                        this.filterForm.page = response.data.data.activePage;
                        this.pagination.total = response.data.data.totalItemsCount;
                        this.pagination.lastPage = response.data.data.pages;
                    }
                }).catch(() => {
                });
        },
        fetchApplications() {
            let params = {...this.filterForm};
            let filter = this.cleanObject(params);


            return this.axios.get(this.$config.urls.application.fetchApplications.url, {params: filter})
                .then(response => {
                    this.zayavki = response.data.data.items;
                    this.pagination.currentPage = response.data.data.activePage;
                    this.filterForm.page = response.data.data.activePage;
                    this.pagination.total = response.data.data.totalItemsCount;
                    this.pagination.lastPage = response.data.data.pages;
                    this.$router.replace({query: params}).catch(() => {
                    });
                }).catch(() => {
                });
        },
        fetchApplication(applicationId) {
            return this.axios.get(this.$config.urls.application.fetchApplication.url.replace(':id', applicationId))
                .then(response => {
                    this.application = response.data.data;
                    return response.data.data;
                }).catch(() => {
                });
        },
        fetchFormOptions() {
            return this.axios.get(this.$config.urls.application.fetchFormOptions.url)
                .then(response => {
                    this.formOptions.types = this.objectToArray(response.data.data.types, true);
                    this.formOptions.resourceTypes = this.objectToArray(response.data.data.resources, true);
                    this.formOptions.statuses = this.objectToArray(response.data.data.statuses, false, true);
                    this.formOptions.creationTypes = this.objectToArray(response.data.data.creationTypes, false, true);
                    this.formOptions.offices = response.data.data.offices;
                    this.formOptions.contestTypes = this.objectToArray(response.data.data.contestTypes, true, true);
                }).catch(() => {
                });
        },
        saveCandidate(applicationId) {

            return this.axios.post(this.$config.urls.application.addCandidate.url.replace(':id', applicationId), this.candidateForm)
                .then(() => {
                    this.snotifySuccess('saveSuccessMsg');
                }).catch(() => {
                });
        },
        confirmApplication(appId) {
            return this.axios.post(this.$config.urls.application.confirmApplication.url.replace(':id', appId)).catch(() => {
            });
        },
        rejectApplication(appId, comment) {
            return this.axios.post(this.$config.urls.application.rejectApplication.url.replace(':id', appId), comment)
                .then(response => {

                    Swal.fire(
                        this.getTranslation('rejected'),
                        this.getTranslation('appRejectedMsg'),
                        'success'
                    );
                    return response.data.data;

                }).catch(() => {
                });
        },

        rejectRetakeApp(appId, data) {
            return this.axios.post(this.$config.urls.application.rejectRetake.url.replace(':id', appId), data)
                .then(() => {

                    Swal.fire(
                        this.getTranslation('rejected'),
                        this.getTranslation('appRejectedMsg'),
                        'success'
                    );

                }).catch(() => {
                });
        },
        deleteCandidate(applicationId, pin) {
            this.$snotify.confirm(this.getTranslation('deleteConfirmMsg'), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation('yes'), action: (toast) => {
                            this.axios.post(this.$config.urls.application.removeCandidate.url.replace(':id', applicationId), {pin: pin})
                                .then(() => {
                                    this.$snotify.remove(toast.id);
                                    this.fetchApplicationCandidates(applicationId);
                                    setTimeout(() => {
                                        this.snotifySuccess('deleteSuccessMsg');
                                    });
                                }).catch(() => {
                                this.snotifyError('serverError');
                            });
                        }, bold: true
                    },
                    {text: this.getTranslation('no'), action: (toast) => this.$snotify.remove(toast.id)}
                ]
            });
        },
        pinService(pin) {
            return this.axios.get(this.$config.urls.application.getPinservice.url, {params: {pin: pin}})
                .then(async response => {
                    if (!response.data.status)
                        throw Error;

                    let photo = await this.axios.get(this.$config.urls.application.photoByPin.url, {
                        params: {pin: pin}
                    });

                    response.data.data.photo = photo.data.data.photo;

                    return response.data.data;
                }).catch(() => {
                });
        },
        save() {
            return this.axios.post(this.$config.urls.application.fetchApplications.url, this.form)
                .then(response => {
                    this.snotifySuccess('saveSuccessMsg');
                    this.$router.push({name: 'api.application.get', params: {id: response.data.data.id}}).catch(() => {
                    })
                }).catch(() => {
                });
        },
        saveAppToken(appId, form) {
            return this.axios.post(this.$config.urls.application.generateToken.url.replace(':id', appId), form).then(response => {
                this.snotifySuccess('saveSuccessMsg');
                return response;
            }).catch(() => {
            });
        },
        deleteApplication(applicationId) {
            this.$snotify.confirm(this.getTranslation('deleteConfirmMsg'), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation('yes'), action: (toast) => {
                            this.axios.delete(this.$config.urls.application.fetchApplication.url.replace(':id', applicationId))
                                .then(() => {
                                    this.fetchApplications();
                                    this.$snotify.remove(toast.id);
                                    setTimeout(() => {
                                        this.snotifySuccess('deleteSuccessMsg');
                                    });
                                }).catch(() => {
                                this.snotifyError('serverError');
                            });
                        }, bold: true
                    },
                    {text: this.getTranslation('no'), action: (toast) => this.$snotify.remove(toast.id)}
                ]
            });
        },
    }
};
export default applicationMixin;
